module.exports = __webpack_public_path__ + "img/MX-C150093A-BD.2c6b49ce.png";